export function createFileSystem(fs) {
    var requireFsError = '';
    if (!fs) {
        try {
            // eslint-disable-next-line
            fs = eval("require('fs')"); // Use eval to trick the linter
        }
        catch (err) {
            requireFsError = err.toString();
        }
    }
    var readFile = fs
        ? function (filePath) {
            return new Promise(function (res, rej) {
                fs.readFile(filePath, function (err, buffer) {
                    return err ? rej(err) : res(buffer);
                });
            });
        }
        : function () {
            throw new Error("readFile - failed to require fs in nodejs environment with error: ".concat(requireFsError));
        };
    return {
        readFile: readFile
    };
}
